import { faGavel } from '@fortawesome/pro-light-svg-icons/faGavel';
import Button from '@propertypal/web-ui/src/buttons/Button';
import FontAwesomeIcon from '@propertypal/web-ui/src/icons/FontAwesomeIcon';
import { Text } from '@propertypal/web-ui/src/typography';
import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';
import { Container, ButtonContainer, TextBox } from './UpcomingAuctionsBox.style';

interface Props {
  wideDisplay?: boolean;
}

const UpcomingAuctionsBox: React.FC<Props> = (props) => {
  const { textLight } = useTheme();

  return (
    <Container data-testid="upcoming-auctions-box" $wideDisplay={props.wideDisplay}>
      <FontAwesomeIcon icon={faGavel} size={48} />

      <TextBox $wideDisplay={props.wideDisplay}>
        <Text fontSize={20} mb={6} fontWeight="bold">
          View all Upcoming Auctions
        </Text>
        <Text color={textLight}>(Get a full list of dates, times and venues)</Text>
      </TextBox>

      <ButtonContainer>
        <Link href="/upcoming-auctions" prefetch={false}>
          <Button type="button">View Upcoming Auctions</Button>
        </Link>
      </ButtonContainer>
    </Container>
  );
};

export default UpcomingAuctionsBox;
